(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbIndexes',[IndexesDirective])
		.controller('IndexesController', [
			'smbIndexTypesDataTypes',
			IndexesController
		]);

	var templateUrl = require('./indexTypesPanel.template');
	function IndexesDirective() {
		return {
			restrict: 'E',
			controller: IndexesController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				indextypes: '=',
				status: '='
			}
		};
	}

	function IndexesController(smbIndexTypesDataTypes) {
		var vm = this;
		vm.dataTypes = smbIndexTypesDataTypes;
		vm.stringFieldRegex = /^[^<>:"/\\|?*]*$/i;

		if(vm.status) {
			Object.defineProperty(vm.status, 'isValid', {
				enumerable: true,
				get : function(){
					return Object.keys(vm.fieldsForm.$error).length < 1;
				}
			});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/indexTypesPanel/indexTypesPanel.js
// module id = 91
// module chunks = 1